<template>
  <v-main>
    <v-overlay v-if="closed === null">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row v-if="closed" class="ma-5">
      <v-col cols="12" sm="8" md="6" lg="4" v-html="closedMessage"> </v-col>
    </v-row>
    <div v-else>
      <v-card v-if="timedout">El enlace ha caducado.</v-card>
      <v-card v-else class="ma-5">
        <v-toolbar color="primary" dark flat>
          <v-card-title class="font-weight-light">
            {{ email }}
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn @click="confirm" large color="blue darken-4">Terminar</v-btn>
        </v-toolbar>
        <v-card-text color="primary" flat dark height="170">
          <p>
            Antes de realizar cualquier solicitud, rogamos revise las
            condiciones particulares de cada actividad, disponibles en
            <a href="http://www.liceosorolla.es" target="_blank"
              >colegioliceosorolla.es</a
            >
            para las actividades organizadas por el colegio o en
            <a href="http://www.deportesorolla.com" target="_blank"
              >deportesorolla.com</a
            >
            para las actividades organizadas por el club deportivo.
          </p>
          <p>
            Cada uno de sus hijos/as aparecerá en una pestaña diferente. Las
            actividades mostradas corresponden a las ofertadas para el curso de
            cada uno.
          </p>
          <p>
            En el caso de que aparezcan varios horarios o grupos en la
            actividad, puede seleccionar tantos como haya disponibles. Una vez
            finalizado el plazo de inscripciones, le informaremos del
            grupo/horario finalmente asignado.
          </p>
          <p>
            <b
              >No olvide pulsar el botón
              <span class="button">Terminar</span> para confirmar la gestión. Si
              todo es correcto recibirá una notificación al correo electrónico
              que se encuentra en nuestra base de datos.</b
            >
          </p>
        </v-card-text>
        <v-toolbar height="10" color="primary" dark flat>
          <template v-slot:extension>
            <v-tabs v-model="selectedSon">
              <v-tabs-slider color="white" height="10"></v-tabs-slider>
              <v-tab :key="indexSon" v-for="(son, indexSon) in sons">
                {{ getSonName(son.name) }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-tabs-items v-if="sons.length > 0" v-model="selectedSon" class="pa-4">
          <v-tab-item :key="indexSon" v-for="(son, indexSon) in sons">
            <v-subheader color="primary">ACTIVIDADES DISPONIBLES</v-subheader>
            <div v-if="son.activities.length > 0">
              <v-card
                color="blue lighten-5"
                :key="indexActivity"
                v-for="(activity, indexActivity) in son.activities"
                class="ma-3"
              >
                <v-toolbar dense height="35" color="primary" flat dark>
                  <v-card-title>{{ activity.name }} </v-card-title>
                  <v-spacer></v-spacer>
                  <span v-if="activity.price" class="price"
                    >{{
                      parseFloat(activity.price).toFixed(2).replace(".", ",")
                    }}
                    € / mes</span
                  >
                </v-toolbar>
                <v-card-text
                  class="images ma-0 pa-0 mt-1"
                  v-if="activity.images && activity.images.length > 0"
                >
                  <v-img
                    dark
                    class="thumbnail"
                    :key="indexImage"
                    v-for="(image, indexImage) in activity.images"
                    :src="image.thumbnailUrl"
                    width="78"
                    height="70"
                    @click="showImage(image)"
                  >
                  </v-img>
                </v-card-text>
                <v-card-text v-if="activity.description">{{
                  activity.description
                }}</v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <v-btn
                    class="pl-1 mr-3 mb-3"
                    :class="{
                      'pr-13': !group.enrolled,
                    }"
                    :color="group.enrolled ? 'green' : 'primary'"
                    rounded
                    outlined
                    :key="indexGroup"
                    v-for="(group, indexGroup) in activity.groups"
                    @click="enroll(indexSon, indexActivity, indexGroup)"
                  >
                    <div v-if="group.schedule.trim() !== ''">
                      <div
                        class="when"
                        :key="indexWhen"
                        v-for="(when, indexWhen) in group.schedule.split('/')"
                      >
                        <v-avatar
                          size="27"
                          class="white--text mr-2 font-weight-bold"
                          :color="group.enrolled ? 'green' : 'primary'"
                          >{{ when.split(" ")[0] }}</v-avatar
                        >
                        {{ when.split(" ")[1].replace("-", " - ") }}
                        <v-icon
                          v-if="
                            indexWhen < group.schedule.split('/').length - 1
                          "
                          >mdi-slash-forward</v-icon
                        >
                      </div>
                    </div>
                    <div v-else>
                      <v-avatar
                        size="27"
                        class="white--text mr-2 font-weight-bold"
                        :color="group.enrolled ? 'green' : 'primary'"
                        ><v-icon small>mdi-help</v-icon></v-avatar
                      >
                      Horario por determinar
                    </div>
                    <span
                      v-if="group.name && group.name.trim() !== ''"
                      class="group-name"
                      >({{ group.name }})</span
                    >
                    <v-icon v-if="group.enrolled" color="green" large
                      >mdi-check</v-icon
                    >
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text class="pb-0">
                  <v-textarea
                    v-if="comments[son.id]"
                    :value="comments[son.id][activity.id]"
                    @change="$set(comments[son.id],activity.id,$event)"
                    rows="1"
                    placeholder="Indique aquí cualquier cuestión que debamos tener en cuenta a la hora de gestionar su solicitud"
                    auto-grow
                    label="Observaciones"
                  ></v-textarea>
                  <!--<v-textarea
                    v-model="activity.comments"
                    rows="1"
                    placeholder="Indique aquí cualquier cuestión que debamos tener en cuenta a la hora de gestionar su solicitud"
                    auto-grow
                    label="Observaciones"
                  ></v-textarea>-->
                </v-card-text>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-dialog v-model="imagePanel" width="60%">
        <v-card color="#0D47A1">
          <v-img :src="currentImage"></v-img>
        </v-card>
      </v-dialog>
      <v-dialog v-model="privacyDialog" width="60%" persistent>
        <v-card>
          <v-card-text class="pa-4 privacy">
            <h1>INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS EN ESPACIO WEB</h1>

            Datos del responsable del tratamiento de los datos
            <p>
              Los datos obtenidos a través de la presente página web serán
              tratados por Liceo Sorolla y Club Deportivo Elemental Prodet
              Pozuelo en calidad de corresponsables.
            </p>
            <br />
            <p>Nombre del responsable: <b>LICEO SOROLLA S.L.</b></p>
            <p>Titular: B28761567</p>
            <p>
              Dirección: AVENIDA BULARAS, 4 28224, POZUELO DE ALARCON, MADRID.
            </p>
            <p>
              Correo electrónico:
              <span class="mail"
                ><a href="mailto:privacidad@liceosorolla.es"
                  >privacidad@liceosorolla.es</a
                ></span
              >
            </p>
            <br />
            <p>
              Nombre del responsable: CLUB DEPORTIVO ELEMENTAL PRODET POZUELO
            </p>
            <p>Titular: G83791525</p>
            <p>
              Dirección: AVENIDA BULARAS, 4 28224, POZUELO DE ALARCON, MADRID.
            </p>
            <p>
              Correo electrónico:
              <span class="mail"
                ><a href="mailto:dpd@deportesorolla.com"
                  >dpd@deportesorolla.com</a
                ></span
              >
            </p>
            <br />
            <h2>FINALIDADES DEL TRATAMIENTO DE DATOS DE CARÁCTER PERSONAL.</h2>

            El tratamiento que realizan Liceo Sorolla y Club Deportivo Elemental
            Prodet Pozuelo tiene como finalidad mantener, desarrollar y
            controlar las actividades extraescolares ofrecidas por el centro a
            sus alumnos, así como informar a los alumnos y sus familias, del
            desarrollo de cada una de ellas.

            <p>Los fines del tratamiento son:</p>

            <ul>
              <li>
                Para la gestión de las actividades extraescolares ofrecidas por
                el centro
              </li>

              <li>
                Tratamos sus datos de carácter personal únicamente en el
                ejercicio de la finalidad enunciada.
              </li>

              <li>
                Para el desarrollo y mantenimiento de la relación jurídica
                contraída en la contratación de actividades extraescolares.
              </li>
            </ul>

            <h2>CÓMO RECOGEMOS SUS DATOS DE CARÁCTER PERSONAL.</h2>

            En primer lugar… ¿Qué información recogemos? A través del presente
            portal únicamente recogemos el correo electrónico dado de alta en la
            entidad Liceo Sorolla, S.L., el cual sirve de llave de acceso a los
            relacionados con las actividades extraescolares de los alumnos,
            posteriormente se recogerán para el alta en las actividades
            extraescolares los siguientes datos.

            <ol>
              <li>
                Padres: Nombre completo, dirección de correo electrónico, forma
                de pago, teléfono de contacto
              </li>
              <li>
                Alumnos: Nombre completo, género, curso, sección, fecha de
                nacimiento, alergias y lesiones relativas a los menores.
              </li>
            </ol>

            En ningún caso un usuario podrá acceder a datos relativos a otros
            alumnos, pudiendo visualizar únicamente los datos pertenecientes a
            sus hijos a través de la segmentación descrita.

            <h2>DERECHOS EN EL TRATAMIENTO DE DATOS</h2>

            Para todos los tratamientos de datos presentes en esta política de
            privacidad, podrá ejercitar los derechos de acceso, rectificación,
            supresión, oposición, y portabilidad, y cualquier otro derivado de
            la aplicación del RGPD, para lo cual puede enviar un correo
            electrónico a las direcciones facilitadas ut supra.

            <h2>LEGITIMACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES</h2>

            ¿Cuál es la legitimación para el tratamiento de sus datos? La
            legitimación para el tratamiento de los datos contemplada en la
            presente política de privacidad es:

            <h3>Ejecución de un contrato de prestación de servicios.</h3>

            ¿A qué destinatarios se comunicarán sus datos? No se cederán datos a
            otros terceros salvo obligación legal, no siendo cesión la
            corresponsabilidad llevada a cabo por Liceo Sorolla y Club Deportivo
            Elemental Prodet Pozuelo y consentida a través de la aceptación de
            la presente política de privacidad. En aquellos casos en que sea
            necesario, los datos de los interesados podrán ser cedidos a los
            organismos legitimados para obtenerlos: Administración Tributaria,
            Tribunales, o cualquier otro por imperativo legal u orden
            administrativa. De igual modo sus datos podrán ser cedidos a
            entidades locales o nacionales, dicha transferencia tiene como base
            legitima la ejecución del contrato de prestación de servicios, al
            tratarse de actividades deportivas es importante mencionar que
            algunas entidades federativas necesitan los datos de los deportivas
            con el fin de participar en los eventos realizados.

            <h2>
              INFORMACIÓN ADICIONAL RELATIVA AL TRATAMIENTO DE DATOS Y
              PRIVACIDAD
            </h2>

            Puede consultar nuestra política completa de protección de datos en
            la web de cada uno de los responsables de datos:

            <a
              href="https://colegioliceosorolla.es/wp-content/uploads/2020/04/privacidad_sorolla.pdf"
              >Liceo Sorolla</a
            >
            <a href="https://www.deportesorolla.com/normativas/">CD Prodet</a>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="privacyDialog = false" color="primary"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-main>
</template>

<script>
/* eslint-disable no-console */
import {
  fs,
  newId,
  tokens,
  students,
  activities,
  messages,
  properties,
} from "../firebaseConfig.js";

import moment from "moment";

export default {
  data() {
    return {
      closed: null,
      closedMessage: "",
      privacyDialog: true,
      imagePanel: false,
      currentImage: null,
      email: "",
      timedout: false,
      sons: [],
      selectedSon: {},
      comments: {},
    };
  },
  created() {
    properties
      .doc("closemessage")
      .get()
      .then((closeRef) => {
        if (closeRef.exists) {
          this.closed = closeRef.data().active;
          this.closedMessage = closeRef.data().message;
        }
        tokens
          .doc(this.$route.params.token)
          .get()
          .then((tokenRef) => {
            if (tokenRef.exists) {
              this.email = tokenRef.data().email;
              students
                .where("fatherEmail", "==", tokenRef.data().email)
                .get()
                .then((studentsRef) => {
                  if (studentsRef.size > 0) {
                    this.getSons(studentsRef);
                  } else {
                    students
                      .where("motherEmail", "==", tokenRef.data().email)
                      .get()
                      .then((studentsRef) => {
                        if (studentsRef.size > 0) {
                          this.getSons(studentsRef);
                        } else {
                          this.timedout = true;
                        }
                      });
                  }
                });
            } else {
              this.timedout = true;
            }
          });
      });
  },
  methods: {
    confirm() {
      this.sons.forEach((son) => {
        son.activities.forEach(async (activity) => {
          let activityQuery = activities.doc(activity.id).get()
          let dbGroups = (await activityQuery).data().groups;
          console.log(activity.groups, dbGroups)
          activity.groups.forEach((group) => {
            if (!group.enrolled && dbGroups[group.id].students[son.id]) {
              console.log('Eliminar');
              activities.doc(activity.id).update({
                [`groups.${group.id}.students.${son.id}`]: fs.FieldValue.delete()
              })
            }
            if (group.enrolled) {
              activities.doc(activity.id).update({
                [`groups.${group.id}.students.${son.id}`]: {
                  id: son.id,
                  index: 0,
                  comments: this.comments[son.id][activity.id] || '',
                  name: son.name,
                  group: son.group,
                  date: new Date(),
                  priority: 1,
                  email: this.email,
                  parentName:
                    this.email === son.fatherEmail
                      ? son.fatherName
                      : son.motherName,
                  parentGender:
                    this.email === son.fatherEmail ? "male" : "female",
                }
              })
            }
          })
        })
      })
      this.prepareParentData();
    },
    prepareParentData() {
      let parent = {
        email: this.email,
      };
      students
        .where("fatherEmail", "==", this.email)
        .get()
        .then((studentsRef) => {
          if (studentsRef.size > 0) {
            parent.name =
              this.showName(studentsRef.docs[0].data().fatherName) || "padre";
            parent.gender = "male";
            this.prepareConfirmationMessage(parent);
          } else {
            students
              .where("motherEmail", "==", this.email)
              .get()
              .then((studentsRef) => {
                parent.name =
                  this.showName(studentsRef.docs[0].data().motherName) ||
                  "madre";
                parent.gender = "female";
                this.prepareConfirmationMessage(parent);
              });
          }
        });
    },
    prepareConfirmationMessage(parent) {
      let message = ``;
      message = `<p>Estimad${parent.gender === "male" ? "o" : "a"} ${
        parent.name
      }:</p>`;
      message +=
        "<p>Aquí tiene un resumen de la gestión que acaba de realizar.</p>";
      message +=
        "<p>Por favor, revise que todo es correcto. Si encuentra alguna discrepancia comuníquenoslo respondiendo a este correo y resolveremos la incidencia manteniendo la fecha en que se realizó la gestión inicial.</p>";
      message += `<p>También puede ponerse en contacto con nosotros si tiene cualquier otra consulta, estaremos encantados de atenderle.</p>`;
      message += `<p>Fecha de la gestión: <b class="gray">${moment(
        new Date()
      ).format("D [de] MMMM [a las] HH:mm[h]")}</b></p>`;

      let nSons = 0;
      this.sons.forEach((son) => {
        let nActivities = 0;
        son.activities.forEach((activity) => {
          let nGroup = 0;
          activity.groups.forEach((group) => {
            if (group.enrolled) nGroup++;
          });
          if (nGroup > 0) nActivities++;
        });
        if (nActivities > 0) nSons++;
      });
      if (nSons) {
        this.sons.forEach((son) => {
          let nActivities = 0;
          son.activities.forEach((activity) => {
            let nGroup = 0;
            activity.groups.forEach((group) => {
              if (group.enrolled) nGroup++;
            });
            if (nGroup > 0) nActivities++;
          });
          if (nActivities) {
            message += `<h3 class="son-name">${this.showName(son.name)}</h3>`;
            message += `<ul>`;
            son.activities.forEach((activity) => {
              let nGroups = 0;
              activity.groups.forEach((group) => {
                if (group.enrolled) nGroups++;
              });
              if (nGroups > 0) {
                message += `<li><h4>${activity.name}</h4>`;
                message += `<p class="gray"><b>Grupos: </b>`;
                activity.groups.forEach((group) => {
                  if (group.enrolled) {
                    message += `<span class="group">${
                      group.schedule ? group.schedule : "Sin horario confirmado"
                    } ${group.name ? " (" + group.name + ")" : ""}</span>`;
                  }
                });
                message += `</p><b class="gray">Observaciones: </b>${
                  this.comments[son.id] && this.comments[son.id][activity.id]
                    ? this.comments[son.id][activity.id]
                    : "No se añadió ninguna observación"
                }`;
                message += "</li>";
              }
            });
            message += `</ul>`;
          }
        });
      } else {
        message += `<p>Actualmente no tiene hijos matriculados en ninguna actividad.</p>`;
      }
      message += `<p>Un saludo.</p>`;
      message += `
        <style>
          .gray {
            color: grey;
          }
          .group {
            border: 1px solid lightgrey;
            padding: 0px 5px 0px 5px;
            margin: 0px 5px 0px 5px;
            border-radius: 5px;
          }
          .son-name {
            color: grey;
            margin-top: 20px;
            border-bottom: 1px solid lightgrey;
          }
        </style>
      `;
      let id = newId();
      let theMessage = {
        id,
        email: this.email,
        message,
        date: new Date()
      };
      console.log('mandando mensaje', theMessage);
      messages
        .doc(id)
        .set(theMessage)
        .then(() => {
          this.$router.replace("/confirmation");
        });
    },
    showName(name) {
      if (name.includes(",")) {
        return name.split(",")[1].trim();
      } else {
        return name;
      }
    },
    updateComment(activity, son, $event) {
      this.sons[son].activities[activity].comments = $event;
    },
    getSonName(name) {
      return name.includes(",") ? name.split(",")[1].trim() : name;
    },
    showImage(image) {
      this.currentImage = image.url;
      this.imagePanel = true;
    },
    enroll(son, activity, group) {
      this.sons[son].activities[activity].groups[group].enrolled =
        !this.sons[son].activities[activity].groups[group].enrolled;
    },
    getSons(studentsRef) {
      this.sons = [];
      studentsRef.forEach((student) => {
        let son = { ...student.data(), activities: [] };
        this.$set(this.comments, son.id, {})
        this.sons.push(son);
        activities
          .where("targets", "array-contains", son.group)
          .where("published", "==", true)
          .get()
          .then((activitiesRef) => {
            son.activities = [];
            activitiesRef.forEach((activity) => {
              let theGroups = [];
              Object.values(activity.data().groups).forEach((group) => {
                let enrolled = Object.keys(group.students).indexOf(son.id) >= 0;
                if (enrolled) {
                  this.$set(this.comments[son.id], activity.id, group.students[son.id].comments || '');
                }
                console.log(this.comments);
                theGroups.push({
                  id: group.id,
                  name: group.name,
                  schedule: group.schedule,
                  date: group.date.seconds,
                  enrolled,
                });
              });
              let theActivity = {
                id: activity.data().id,
                name: activity.data().name,
                images: activity.data().images,
                description: activity.data().description,
                groups: theGroups.sort((a, b) => {
                  if (a.date < b.date) {
                    return -1;
                  } else {
                    return 1;
                  }
                }),
              };
              son.activities.push(theActivity);
            });
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.groupSelected {
  background-color: red !important;
}
.images {
  margin: 0px;
  padding-top: 7px;
  width: 100%;
  text-align: center;
  .thumbnail {
    line-height: 30px;
    margin: 0px;
    padding: 0px;
    margin-left: 5px;
    width: 78px;
    height: 70px;
    overflow: hidden;
    display: inline-block;
  }
}
.price {
  font-size: 1.2em;
}
.group-name {
  margin-left: 5px;
}

.privacy {
  h1 {
    padding: 10px 0px 20px 0px;
    font-size: 1.3em;
  }
  h2 {
    padding: 20px 0px 5px 0px;
    font-size: 1.2em;
  }
  h3 {
    padding: 10px 0px 5px 0px;
    font-size: 1.1em;
  }
  a {
    display: block;
    margin: 10px;
  }
}
.mail {
  display: inline-block;
}
.button {
  border: 1px solid black;
  border-radius: 5px;
  padding: 0px 5px;
  margin: 0px 5px;
  text-transform: uppercase;
}
</style>